/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/content-addon/custom-elements';

import { defineCustomElement as defineOsdsContentAddon } from '@ovhcloud/ods-stencil/components/content-addon/custom-elements/osds-content-addon.js';


export const OsdsContentAddon = /*@__PURE__*/ defineContainer<JSX.OsdsContentAddon>('osds-content-addon', defineOsdsContentAddon);

